import React, { useState, useMemo, useEffect } from "react";
import "../DashboardUnique.css";
import {
  exportGrantVillagesToExcel,
  exportGrantYojanaUnderVillageToExcel,
  exportVillagesToExcel,
  exportVillagesToPDF,
  exportVillageWiseGrantDetailsExcel,
  toIndianCurrency,
  toIndianCurrencyDashboardCard,
} from "../../../MethodMaster/JSXComponentMothod";
import { parse } from "date-fns";
import { useGrantDetailsDataExportExcel } from "../../../API_Master/ExcelAPI";
import { toast } from "react-toastify";

const ShimmerCard = ({ themeIndex = 0 }) => {
  const theme = SHIMMER_THEMES[themeIndex % 5];
  return (
    <div className={`govdash-shimmerCard ${theme}`}>
      <div className="wave"></div>
      <div style={{ width: "48px", height: "48px", borderRadius: "12px", marginBottom: "1rem" }}></div>
      <div style={{ width: "82%", height: "20px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "62%", height: "34px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "52%", height: "16px", marginBottom: "0.5rem" }}></div>
      <div style={{ width: "72%", height: "24px" }}></div>
    </div>
  );
};

const THEMES = ["yojna-glass-0", "yojna-glass-1", "yojna-glass-2", "yojna-glass-3", "yojna-glass-4"];
const SHIMMER_THEMES = ["shimmer-theme-0", "shimmer-theme-1", "shimmer-theme-2", "shimmer-theme-3", "shimmer-theme-4"];

const NoDataCard = () => (
  <div className="govdash-noDataCard">
    <i className="govdash-icon fas fa-chart-line"></i>
    <div className="no-data-title">No Yojna Found</div>
    <div className="no-data-desc">Try adjusting your search</div>
  </div>
);

export default function GrantVillageWiseYojanaGrid({ selVillage = null, yojana = [], onSelect, isLoading = false }) {
  const [search, setSearch] = useState("");
  const themes = ["glass-0", "glass-1", "glass-2", "glass-3", "glass-4"];

  // ADDED: Mutation hook for exporting all grant details
  const { mutate: exportMemberList, isPending: isExporting } = useGrantDetailsDataExportExcel();

  const filteredYojnas = useMemo(() => {
    if (!search.trim()) return yojana.filter((v) => v?.YojnaName?.trim());
    return yojana.filter((v) => v?.YojnaName?.toLowerCase().includes(search.trim().toLowerCase()));
  }, [yojana, search]);
  const handleExcel = () => exportGrantYojanaUnderVillageToExcel(selVillage, filteredYojnas, "Grant_Village_Wise_Yojana");
  // const handlePDF = () => exportVillagesToPDF(selYojna, filteredVillages, "Villages_Under_Yojna")

  // ADDED: Handler for downloading all grant details data
  const handleExportAll = () => {
    toast.dismiss();
    exportMemberList(
      {
        VillageID: selVillage?.VillageID,
        Name: "", // Empty string to fetch all yojanas under the village
      },
      {
        onSuccess: (data) => {
          if (!data?.length) {
            toast.error("No Data Found");
            return;
          }
          const exportData = data.map((item, i) => {
            const displayAmount = item.IsYojanaAmount
              ? `₹${parseFloat(item.YojanaAmount)} × ${parseFloat(item.Amount)} = ₹${parseFloat(item.YojanaAmount) * parseFloat(item.Amount)}`
              : item.Amount
                ? `₹${item.Amount.toLocaleString("en-IN")}`
                : "";
            return {
              ક્રમાંક: i + 1,
              "અનુદાન વર્ષ": item.GrantYear,
              "યોજનાનું નામ": item.YojnaName,
              "અનુદાનની રકમ": displayAmount,
              "કામનું નામ": item.WorkName,
              "એન્ટ્રી તારીખ": item.CreatedByDateTime,
            };
          });
          exportVillageWiseGrantDetailsExcel(exportData, `Grant_Details_${selVillage.Village}`, {
            selYojna: "Grant_Details",
            selVillage: selVillage || "",
            showTitle2: false,
          });
        },
        onError: () => toast.error("Export failed"),
      },
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <h3 className={"govdash-sectionTitle"}>
          Yojana under this village
          {/* &nbsp;&nbsp;&nbsp; */}
          {/* <div className="govdash-totalCountBadge" >

            <span className="govdash-totalNumber">{villages.length}</span>
          </div> */}
        </h3>
        {/* Search Bar */}
        <div className="d-flex gap-2">
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="govdash-searchWrapper">
              <i className="fas fa-search "></i>
              <input type="text" placeholder="Search Yojana Name..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          <div>
            <button onClick={handleExcel} className="govdash-excelBtn mt-4">
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
          {/* ADDED: New button for downloading all data */}
          <div>
            <button onClick={handleExportAll} className="govdash-excelBtn mt-4" disabled={isExporting}>
              {isExporting ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Exporting...
                </>
              ) : (
                <>
                  <i className="fas fa-download"></i> Download All Data
                </>
              )}
            </button>
          </div>
          {/* <div>
          <button onClick={handlePDF} className="govdash-pdfBtn mt-4">
            <i className="fas fa-file-pdf"></i> Download PDF
          </button>
          </div> */}
        </div>
      </div>

      <div className="govdash-grid6">
        {isLoading ? (
          Array(20)
            .fill()
            .map((_, i) => <ShimmerCard key={i} themeIndex={i} />)
        ) : filteredYojnas.length > 0 ? (
          filteredYojnas.map((y, i) => {
            const theme = THEMES[i % 5];
            return (
              <div key={y.GramYojnaID} className={`govdash-yojnaCard ${theme}`} onClick={() => onSelect(y)}>
                <i className={`govdash-icon ${y?.IconName || "fas fa-heart"}`}></i>
                <div className="govdash-yojnaName">{y?.YojnaName}</div>
                <div className="govdash-labharti">{y?.GrantDetailCount.toLocaleString()}</div>
                <div style={{ fontSize: "0.9rem", color: "#64748b", marginBottom: "0.25rem" }}>Grant Details</div>
                {/* Siddharth 06-12-2025 */}
                {/* {y?.TotalAmount ? <div className="govdash-amount">₹{y?.TotalAmount.toLocaleString()}</div> : ""} */}

                {/* {y?.TotalAmount ? <div className="govdash-amount">  {y?.IsYojanaAmount == 1  ?  `₹${((parseInt(y?.YojanaAmount || 0) * parseInt(y?.TotalAmount || 0))?.toLocaleString()) || ""}`  : `₹${y?.TotalAmount?.toLocaleString()}`}</div> : ""} */}
                {y?.TotalAmount ? (
                  <div className="govdash-amount">
                    {" "}
                    {y?.IsYojanaAmount == 1
                      ? toIndianCurrencyDashboardCard(parseFloat(y?.YojanaAmount || 0) * parseFloat(y?.TotalAmount || 0)) || ""
                      : toIndianCurrencyDashboardCard(y?.TotalAmount || 0)}
                  </div>
                ) : (
                  ""
                )}
                {/* {y?.IsYojanaAmount ? (
                  <div className="govdash-amount">₹{(parseFloat(y?.TotalAmount) * parseFloat(y?.YojanaAmount))?.toLocaleString()}</div>
                ) : y?.TotalAmount ? (
                  <div className="govdash-amount">₹{y?.TotalAmount?.toLocaleString()}</div>
                ) : (
                  ""
                )} */}
                <span className="govdash-statusBadge govdash-active">Active</span>
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
    </>
  );
}
